import '../resources/css/App.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { BrowserRouter, Route, Switch, withRouter, Redirect } from 'react-router-dom';
import SiteLayout from './layout/SiteLayout';
import LoginLayout from './layout/LoginLayout';
import MainLayout from './layout/MainLayout';
import SignupLayout from './layout/SignupLayout';
import ForgotPwdLayout from './layout/ForgotPwdLayout';
import SettingsLayout from "./layout/SettingsLayout";


class App extends Component {
  static propTypes = {
    // Injected by React Redux
    store: PropTypes.object,
    errorMessage: PropTypes.string,
       
    // Injected by React Router
    children: PropTypes.node
  }

  checkThirdPartyLogin = () => {
    let redirectURL;
    if (window.IS_CUSTOM) {
      redirectURL = window.CUSTOM.GOOGLE.redirectURL;
    } else {
      redirectURL = window.CONFIG.GOOGLE.redirectURL;
    }
    return window.location.href.includes(redirectURL + "/?code=");
  }

  componentDidMount() {
    // init config from custom
    console.info("App.js load", new Date());
    if (window.IS_CUSTOM) {
      window.CONFIG.SWS_SERVER_API_URI = window.CUSTOM.SWS_SERVER_API_URI;
      window.CONFIG.SWS_SERVER_WS = window.CUSTOM.SWS_SERVER_WS;
      window.CONFIG.LIMIT_CONFIG = window.CUSTOM.LIMIT_CONFIG;
      window.CONFIG.GOOGLE = window.CUSTOM.GOOGLE;
    }
  }

  render() {
    const params = queryString.parse(window.location.search);

    let rootRedir = window.CONFIG.WEB_ROOT + "/Login";

    if (rootRedir){
      return (
        <div className="App">
          <BrowserRouter>
            <Switch>
              <Route path={ window.CONFIG.WEB_ROOT + "/Login" } exact component={LoginLayout} />
              <Route path={ window.CONFIG.WEB_ROOT + "/Signup" } exact component={SignupLayout} />
              <Route path={ window.CONFIG.WEB_ROOT + "/ForgotPassword" } exact component={ForgotPwdLayout} />
              <Route path={ window.CONFIG.WEB_ROOT + "/site" } exact component={SiteLayout} />
              <Route path={ window.CONFIG.WEB_ROOT + "/settings/:subPage" } exact component={SettingsLayout} />
              {/* <Route path={ window.CONFIG.WEB_ROOT + "/setup" } exact component={InitialSetUpForm} /> */}
              {/* <Route path={ window.CONFIG.WEB_ROOT + "/rftest" } exact component={RfMapTestLayout} /> */}
              <Route path={ window.CONFIG.WEB_ROOT + "/:navName"} exact component={MainLayout} />
              <Route path={ window.CONFIG.WEB_ROOT + "/:navName/:formType" } exact component={MainLayout} />

              {/*--------- Redirect Need after Route ---------*/}
              <Redirect from={ window.CONFIG.WEB_ROOT }
                to={{
                  pathname: rootRedir,
                  state: {
                    urlParams: params
                  }
                }}
              /> 
              <Redirect from='/' to={ rootRedir }/> 
            </Switch>
          </BrowserRouter>
      </div>
      )
    } else {
      return (<></>)
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    errorMessage: state.errorMessage
  }
}

export default withRouter(connect(
  mapStateToProps, 
  {}
)(App))
